import { displayDate, DATE_FORMAT_FULL } from 'utils/date';

export const ALL_CATALOGS_COLUMNS = [
  { name: 'Name', value: 'col1', link: true, primaryAction: true, disableToggle: true },
  {
    name: 'Created at',
    value: 'createdAt',
    formatter: (value, { createdAt }) => displayDate(createdAt, DATE_FORMAT_FULL),
  },
];

export const TABLE_VIEW = 'Tabular';
export const JSON_VIEW = 'JSON';

export const CREATE_GUIDELINES = [
  {
    children:
      'Must be unique. This is case-insensitive (i.e., "inventory" is the same as "INVENTORY")',
    isDisplayed: 'isNotUnique',
  },
  {
    children: [
      'Can only include alphanumeric characters (',
      <strong key="0">a-z</strong>,
      ' ',
      <strong key="1">A-Z</strong>,
      ' ',
      <strong key="2">0-9</strong>,
      ') and dashes (',
      <strong key="3">-</strong>,
      ')',
    ],
    isDisplayed: 'isNotAlphaNumeric',
  },
  {
    children: 'Cannot include spaces or special characters other than dashes',
    isDisplayed: 'isNotAlphaNumeric',
  },
  {
    children: 'Must be fewer than 400 characters',
    isDisplayed: 'isTooLong',
  },
];

export const UPDATE_CATALOG_ITEM_METHOD = {
  JSON: 'JSON',
  CSV: 'CSV',
};

export const SET_MODAL_STATE = 'setModalState';
export const CREATE_CATALOG_MODAL = 'createCatalogModal';
export const DELETE_MODAL = 'deleteModal';
export const CREATE_COLLECTION_MODAL = 'createCollectionModal';

export const INITIAL_REDUCER_STATE = {
  modal: '',
  deleteName: '',
};
